import { render, staticRenderFns } from "./MailQueueList.vue?vue&type=template&id=bdc77b38&scoped=true"
import script from "./MailQueueList.vue?vue&type=script&lang=ts"
export * from "./MailQueueList.vue?vue&type=script&lang=ts"
import style0 from "./MailQueueList.vue?vue&type=style&index=0&id=bdc77b38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc77b38",
  null
  
)

export default component.exports